import { useEffect } from 'react'
import { AdCommonEvents, callPixelEvent } from '@monorepo/service'

export const useTrackingEvents = (isCdaCheck: boolean) => {
  useEffect(() => {
    if (!isCdaCheck) return

    callPixelEvent({ event: AdCommonEvents.Visit })
    callPixelEvent({ event: AdCommonEvents.LandingPageView })
    callPixelEvent({ event: AdCommonEvents.RegNotFinished })
  }, [isCdaCheck])
}